import React, { Fragment, useEffect, useState } from 'react'

import { GET_SUTDENT_AND_ATTENDANCE_RATE_REPORT } from "../../Schema/Report"
import { useQuery } from "@apollo/client";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Components/Include/LoadingPage";

export default function StudentAndAttendanceRateReport({ schoolId, academicYearId, componentRef, academicYearTitle }) {

    const [tableData, setTableData] = useState();
    const [loading, setLoading] = useState(true);
    // console.log("loading", loading)

    const { refetch } = useQuery(GET_SUTDENT_AND_ATTENDANCE_RATE_REPORT, {
        variables: {
            academicYearId: academicYearId ? academicYearId : "",
            schoolId: schoolId ? schoolId : ""
        },
        onCompleted: ({ getStudentAndAttendanceRateReport }) => {
            setTableData(getStudentAndAttendanceRateReport);

            setLoading(false);

        },
        onError: (err) => {
            console.log("Error::", err?.message);
        },
    });

    // console.log("tableData", tableData)

    useEffect(() => { refetch(); setLoading(true) }, [academicYearId, schoolId])

    const headerTitle = [
        "Dream Class Registration #",
        "Dream Students Q2",
        "Drop-outs Q2",
        "Dream Students Q3",
        "Drop-outs Q3",
        "Dream Students Q4",
        "Drop-outs Q4",
    ]

    return (

        <div>
            <table className="company-table" ref={componentRef}>
                <thead>
                    <tr >
                        <th className='dark-blue-header-cell'></th>
                        {
                            headerTitle?.map((e, index) => (
                                <th className='dark-blue-header-cell' key={index} style={{ width: "1300px !important" }} colSpan={5}>{e}</th>
                            )
                            )
                        }
                        <th className='dark-blue-header-cell' colSpan={4}>Average Attendance Rate</th>
                    </tr>


                    <tr>
                        <td className='light-blue-cell'>{academicYearTitle}</td>
                        {
                            headerTitle?.map((_, index) => {
                                return (
                                    <Fragment key={index}>
                                        <td className='light-blue-cell' style={{ width: "50px" }}>Total</td>
                                        <td className='light-blue-cell' style={{ width: "50px" }}>M</td>
                                        <td className='light-blue-cell' style={{ width: "50px" }}>F</td>
                                        <td className='light-blue-cell' style={{ width: "50px" }}>%M</td>
                                        <td className='light-blue-cell' style={{ width: "50px" }}>%F</td>
                                    </Fragment>
                                )
                            })
                        }
                        <td className='light-blue-cell' style={{ width: "50px" }}>Q2</td>
                        <td className='light-blue-cell' style={{ width: "50px" }}>Q3</td>
                        <td className='light-blue-cell' style={{ width: "50px" }}>Q4</td>
                        <td className='light-blue-cell' style={{ width: "50px" }}>Yearly</td>


                    </tr>
                </thead>

                <tbody>

                    {
                        loading ?
                            <tr>
                                <td colSpan={40}>
                                    <LoadingPage />
                                </td>
                            </tr> :

                            !tableData ?
                                <tr>
                                    <td colSpan={40}>
                                        <EmptyData />
                                    </td>
                                </tr>
                                :
                                tableData?.detail_data?.map((d, index) => {
                                    return (
                                        <Fragment key={index}>
                                            {d?.student_and_attendance_rate_by_group?.map((f, index2) => {
                                                return (
                                                    <tr key={index2}>
                                                        <td className='dark-blue-cell' style={{ textAlign: "left" }}>Group {f?.group_name}</td>

                                                        {/* dream class register */}
                                                        <td className='green-cell'>{f?.dream_class_registration?.total}</td>
                                                        <td className='dark-blue-cell'>{f?.dream_class_registration?.male}</td>
                                                        <td className='dark-blue-cell'>{f?.dream_class_registration?.female}</td>
                                                        <td className='dark-blue-cell'>{f?.dream_class_registration?.male_as_percentage}%</td>
                                                        <td className='dark-blue-cell'>{f?.dream_class_registration?.female_as_percentage}%</td>
                                                        {/* dream Q2 */}
                                                        <td className='green-cell'>{f?.dream_student_q2?.total}</td>
                                                        <td className='dark-blue-cell'>{f?.dream_student_q2?.male}</td>
                                                        <td className='dark-blue-cell'>{f?.dream_student_q2?.female}</td>
                                                        <td className='dark-blue-cell'>{f?.dream_student_q2?.male_as_percentage}%</td>
                                                        <td className='dark-blue-cell'>{f?.dream_student_q2?.female_as_percentage}%</td>
                                                        {/* drop_out_q2 Q2 */}
                                                        <td className='green-cell'>{f?.drop_out_q2?.total}</td>
                                                        <td className='dark-blue-cell'>{f?.drop_out_q2?.male}</td>
                                                        <td className='dark-blue-cell'>{f?.drop_out_q2?.female}</td>
                                                        <td className='dark-blue-cell'>{f?.drop_out_q2?.male_as_percentage}%</td>
                                                        <td className='dark-blue-cell'>{f?.drop_out_q2?.female_as_percentage}%</td>

                                                        {/* dream Q3 */}
                                                        <td className='green-cell'>{f?.dream_student_q3?.total}</td>
                                                        <td className='dark-blue-cell'>{f?.dream_student_q3?.male}</td>
                                                        <td className='dark-blue-cell'>{f?.dream_student_q3?.female}</td>
                                                        <td className='dark-blue-cell'>{f?.dream_student_q3?.male_as_percentage}%</td>
                                                        <td className='dark-blue-cell'>{f?.dream_student_q3?.female_as_percentage}%</td>
                                                        {/* drop_out_q3 Q3 */}
                                                        <td className='green-cell'>{f?.drop_out_q3?.total}</td>
                                                        <td className='dark-blue-cell'>{f?.drop_out_q3?.male}</td>
                                                        <td className='dark-blue-cell'>{f?.drop_out_q3?.female}</td>
                                                        <td className='dark-blue-cell'>{f?.drop_out_q3?.male_as_percentage}%</td>
                                                        <td className='dark-blue-cell'>{f?.drop_out_q3?.female_as_percentage}%</td>

                                                        {/* dream Q4 */}
                                                        <td className='green-cell'>{f?.dream_student_q4?.total}</td>
                                                        <td className='dark-blue-cell'>{f?.dream_student_q4?.male}</td>
                                                        <td className='dark-blue-cell'>{f?.dream_student_q4?.female}</td>
                                                        <td className='dark-blue-cell'>{f?.dream_student_q4?.male_as_percentage}%</td>
                                                        <td className='dark-blue-cell'>{f?.dream_student_q4?.female_as_percentage}%</td>
                                                        {/* drop_out_q4 Q4 */}
                                                        <td className='green-cell'>{f?.drop_out_q4?.total}</td>
                                                        <td className='dark-blue-cell'>{f?.drop_out_q4?.male}</td>
                                                        <td className='dark-blue-cell'>{f?.drop_out_q4?.female}</td>
                                                        <td className='dark-blue-cell'>{f?.drop_out_q4?.male_as_percentage}%</td>
                                                        <td className='dark-blue-cell'>{f?.drop_out_q4?.female_as_percentage}%</td>

                                                        {/* rate */}
                                                        <td className='dark-blue-cell'>{(f?.q2_attendance_rate?.toFixed())}%</td>
                                                        <td className='dark-blue-cell'>{(f?.q3_attendance_rate?.toFixed())}%</td>
                                                        <td className='dark-blue-cell'>{(f?.q4_attendance_rate?.toFixed())}%</td>
                                                        <td className='dark-blue-cell'>{(f?.yearly_attendance_rate?.toFixed())}%</td>
                                                    </tr>
                                                )
                                            })}
                                            <tr>
                                                {/* level name */}
                                                <td className='green-cell' style={{ textAlign: "left" }}> Grade {d?.level_name}</td>
                                                {/* dream class register */}
                                                <td className='green-cell'>{d?.dream_class_registration?.total}</td>
                                                <td className='green-cell'>{d?.dream_class_registration?.male}</td>
                                                <td className='green-cell'>{d?.dream_class_registration?.female}</td>
                                                <td className='green-cell'>{d?.dream_class_registration?.male_as_percentage}%</td>
                                                <td className='green-cell'>{d?.dream_class_registration?.female_as_percentage}%</td>
                                                {/* dream Q2 */}
                                                <td className='green-cell'>{d?.dream_student_q2?.total}</td>
                                                <td className='green-cell'>{d?.dream_student_q2?.male}</td>
                                                <td className='green-cell'>{d?.dream_student_q2?.female}</td>
                                                <td className='green-cell'>{d?.dream_student_q2?.male_as_percentage}%</td>
                                                <td className='green-cell'>{d?.dream_student_q2?.female_as_percentage}%</td>
                                                {/* drop_out_q2 Q2 */}
                                                <td className='green-cell'>{d?.drop_out_q2?.total}</td>
                                                <td className='green-cell'>{d?.drop_out_q2?.male}</td>
                                                <td className='green-cell'>{d?.drop_out_q2?.female}</td>
                                                <td className='green-cell'>{d?.drop_out_q2?.male_as_percentage}%</td>
                                                <td className='green-cell'>{d?.drop_out_q2?.female_as_percentage}%</td>

                                                {/* dream Q3 */}
                                                <td className='green-cell'>{d?.dream_student_q3?.total}</td>
                                                <td className='green-cell'>{d?.dream_student_q3?.male}</td>
                                                <td className='green-cell'>{d?.dream_student_q3?.female}</td>
                                                <td className='green-cell'>{d?.dream_student_q3?.male_as_percentage}%</td>
                                                <td className='green-cell'>{d?.dream_student_q3?.female_as_percentage}%</td>
                                                {/* drop_out_q3 Q3 */}
                                                <td className='green-cell'>{d?.drop_out_q3?.total}</td>
                                                <td className='green-cell'>{d?.drop_out_q3?.male}</td>
                                                <td className='green-cell'>{d?.drop_out_q3?.female}</td>
                                                <td className='green-cell'>{d?.drop_out_q3?.male_as_percentage}%</td>
                                                <td className='green-cell'>{d?.drop_out_q3?.female_as_percentage}%</td>

                                                {/* dream Q4 */}
                                                <td className='green-cell'>{d?.dream_student_q4?.total}</td>
                                                <td className='green-cell'>{d?.dream_student_q4?.male}</td>
                                                <td className='green-cell'>{d?.dream_student_q4?.female}</td>
                                                <td className='green-cell'>{d?.dream_student_q4?.male_as_percentage}%</td>
                                                <td className='green-cell'>{d?.dream_student_q4?.female_as_percentage}%</td>
                                                {/* drop_out_q4 Q4 */}
                                                <td className='green-cell'>{d?.drop_out_q4?.total}</td>
                                                <td className='green-cell'>{d?.drop_out_q4?.male}</td>
                                                <td className='green-cell'>{d?.drop_out_q4?.female}</td>
                                                <td className='green-cell'>{d?.drop_out_q4?.male_as_percentage}%</td>
                                                <td className='green-cell'>{d?.drop_out_q4?.female_as_percentage}%</td>

                                                {/* rate */}
                                                <td className='dark-green-cell'>{(d?.q2_attendance_rate?.toFixed())}%</td>
                                                <td className='dark-green-cell'>{(d?.q3_attendance_rate?.toFixed())}%</td>
                                                <td className='dark-green-cell'>{(d?.q4_attendance_rate?.toFixed())}%</td>
                                                <td className='dark-green-cell'>{(d?.yearly_attendance_rate?.toFixed())}%</td>
                                            </tr>
                                        </Fragment>
                                    )
                                })
                    }

                    <tr>
                        <td className='dark-green-cell'>OVERALL TOTAL</td>
                        {/* dream class register */}
                        <td className='dark-green-cell'>{tableData?.dream_class_registration?.total}</td>
                        <td className='dark-green-cell'>{tableData?.dream_class_registration?.male}</td>
                        <td className='dark-green-cell'>{tableData?.dream_class_registration?.female}</td>
                        <td className='dark-green-cell'>{tableData?.dream_class_registration?.male_as_percentage}%</td>
                        <td className='dark-green-cell'>{tableData?.dream_class_registration?.female_as_percentage}%</td>
                        {/* dream Q2 */}
                        <td className='dark-green-cell'>{tableData?.dream_student_q2?.total}</td>
                        <td className='dark-green-cell'>{tableData?.dream_student_q2?.male}</td>
                        <td className='dark-green-cell'>{tableData?.dream_student_q2?.female}</td>
                        <td className='dark-green-cell'>{tableData?.dream_student_q2?.male_as_percentage}%</td>
                        <td className='dark-green-cell'>{tableData?.dream_student_q2?.female_as_percentage}%</td>
                        {/* drop_out_q2 Q2 */}
                        <td className='dark-green-cell'>{tableData?.drop_out_q2?.total}</td>
                        <td className='dark-green-cell'>{tableData?.drop_out_q2?.male}</td>
                        <td className='dark-green-cell'>{tableData?.drop_out_q2?.female}</td>
                        <td className='dark-green-cell'>{tableData?.drop_out_q2?.male_as_percentage}%</td>
                        <td className='dark-green-cell'>{tableData?.drop_out_q2?.female_as_percentage}%</td>

                        {/* dream Q3 */}
                        <td className='dark-green-cell'>{tableData?.dream_student_q3?.total}</td>
                        <td className='dark-green-cell'>{tableData?.dream_student_q3?.male}</td>
                        <td className='dark-green-cell'>{tableData?.dream_student_q3?.female}</td>
                        <td className='dark-green-cell'>{tableData?.dream_student_q3?.male_as_percentage}%</td>
                        <td className='dark-green-cell'>{tableData?.dream_student_q3?.female_as_percentage}%</td>
                        {/* drop_out_q3 Q3 */}
                        <td className='dark-green-cell'>{tableData?.drop_out_q3?.total}</td>
                        <td className='dark-green-cell'>{tableData?.drop_out_q3?.male}</td>
                        <td className='dark-green-cell'>{tableData?.drop_out_q3?.female}</td>
                        <td className='dark-green-cell'>{tableData?.drop_out_q3?.male_as_percentage}%</td>
                        <td className='dark-green-cell'>{tableData?.drop_out_q3?.female_as_percentage}%</td>

                        {/* dream Q4 */}
                        <td className='dark-green-cell'>{tableData?.dream_student_q4?.total}</td>
                        <td className='dark-green-cell'>{tableData?.dream_student_q4?.male}</td>
                        <td className='dark-green-cell'>{tableData?.dream_student_q4?.female}</td>
                        <td className='dark-green-cell'>{tableData?.dream_student_q4?.male_as_percentage}%</td>
                        <td className='dark-green-cell'>{tableData?.dream_student_q4?.female_as_percentage}%</td>
                        {/* drop_out_q4 Q4 */}
                        <td className='dark-green-cell'>{tableData?.drop_out_q4?.total}</td>
                        <td className='dark-green-cell'>{tableData?.drop_out_q4?.male}</td>
                        <td className='dark-green-cell'>{tableData?.drop_out_q4?.female}</td>
                        <td className='dark-green-cell'>{tableData?.drop_out_q4?.male_as_percentage}%</td>
                        <td className='dark-green-cell'>{tableData?.drop_out_q4?.female_as_percentage}%</td>

                        {/* rate */}
                        <td className='dark-green-cell'>{(tableData?.q2_attendance_rate?.toFixed())}%</td>
                        <td className='dark-green-cell'>{(tableData?.q3_attendance_rate?.toFixed())}%</td>
                        <td className='dark-green-cell'>{(tableData?.q4_attendance_rate?.toFixed())}%</td>
                        <td className='dark-green-cell'>{(tableData?.yearly_attendance_rate?.toFixed())}%</td>
                    </tr>
                </tbody>
            </table>
        </div>

    )
}
